/**
 * Realtime Redux Slice
 * Tracks unified WebSocket connection state.
 * Components use selectRealtimeConnected to adjust polling intervals.
 */

import { createSlice } from '@reduxjs/toolkit';

const realtimeSlice = createSlice({
  name: 'realtime',
  initialState: {
    connected: false,
    lastConnected: null,
  },
  reducers: {
    setConnected: (state, action) => {
      state.connected = action.payload;
      if (action.payload) {
        state.lastConnected = new Date().toISOString();
      }
    },
  },
});

export const { setConnected } = realtimeSlice.actions;

export const selectRealtimeConnected = (state) => state.realtime.connected;

export default realtimeSlice.reducer;
